import $ from 'jquery';

const token = $('meta[name="csrf-token"]').attr('content');

if (token != null) {
  $.ajaxPrefilter((options, originalOptions, jqXHR) => {
    jqXHR.setRequestHeader('X-CSRF-Token', token);
  });
}
